import {safeLocalStorage} from '@utils/safeStorages';

export const getOidSegments = () => {
  try {
    const omicronParams = safeLocalStorage.getItem('omicronParams');

    if (!omicronParams) {
      return {};
    }

    const segments: Record<string, string> = JSON.parse(omicronParams);

    return segments;
  } catch (error) {
    console.error('Error parsing omicronParams:', error);

    return {};
  }
};

export const getOid = () => {
  try {
    return safeLocalStorage.getItem('userId') || '';
  } catch (error) {
    console.error('Error accessing localStorage:', error);

    return '';
  }
};
